<template>
    <v-dialog v-model="dialog" persistent max-width="600" overlay-color="grey darken-1" overlay-opacity=".5" @click:outside="isTranslating ? null : closeSubtitleTranslation(false)">
        <v-card v-if="!isTranslating" class="rounded-xl">
            <v-card-title style="word-break: normal" class="justify-center align-center">
                <!-- <span v-if="page==='audioElement'" class="font-weight-bold text-h5 text-center">Translate Subtitles</span> -->
                <span class="font-weight-bold text-h5 text-center">Translate Subtitles for: </span>
            </v-card-title>
            <v-card-subtitle style="word-break: normal" class="justify-center align-center">
                <p class="font-weight-bold text-h6 text-center mt-2">{{ audioData.audioData.title }}</p>
            </v-card-subtitle>

            <v-row justify="center" class="mx-0">
                <v-col cols="12" xl="10" lg="10" md="10" sm="12">
                    <v-autocomplete
                        v-model="selectedTranslationLanguage"
                        label="Select a language (required)"
                        :items="languageCodes"
                        item-text="text"
                        item-value="value"
                        return-object
                        outlined
                        persistent-hint
                        hint="Select the language you will be translating the subtitles into"
                        :disabled="false"
                    ></v-autocomplete>

                </v-col>
            </v-row>

            <v-card-actions>
                <v-row justify="end" no-gutters class="ma-0 pt-3">
                    <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="closeSubtitleTranslation(false)">Cancel</v-btn>
                    <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="saveSubtitleTranslation" :disabled="selectedTranslationLanguage === null">Save</v-btn>
                </v-row>
            </v-card-actions>

        </v-card>
        <v-card v-else class="rounded-xl">
            <v-card-title style="word-break: normal" class="justify-center align-center">
                <span v-if="successText === ''" class="mb-2 font-weight-bold text-h5 text-center">Hold tight while we translate your subtitles</span>
                <span v-else class="mb-2 font-weight-bold text-h5 text-center">{{successText}}</span>
            </v-card-title>

            <v-row justify="center" no-gutters>
                <v-col align="center">
                    <v-progress-circular v-if="successText === ''" indeterminate color="primary" :size="100"></v-progress-circular>
                    <v-icon v-else-if="successText === 'Subtitles translated successfully!'" color="primary" size="100">mdi-check-circle</v-icon>
                    <v-icon v-else color="red" size="100">mdi-close-circle</v-icon>
                </v-col>
            </v-row>

            <v-card-actions>
                <v-row justify="end" no-gutters class="ma-0 pt-3">
                    <!-- <v-btn :color="$vuetify.theme.dark ? 'amber' : 'primary'" text @click="closeSubtitleTranslation">Close</v-btn> -->
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// import firebase from "../../firebaseConfig.js";
import { getFunctions, httpsCallable } from "firebase/functions";
export default {
    name: "SubtitleTranslation",
    props: ["dialog", "page", "audioData"],
    data: function() {
        return {
            isTranslating: false,
            selectedTranslationLanguage: null,
            successText: "",
        };
    },
    methods: {
        closeSubtitleTranslation: function(wasTranslated) {
            this.$emit("close-subtitle-translation", wasTranslated);
        },
        saveSubtitleTranslation: async function() {
            let wasSuccessfullyTranslated = true;
            try {
                this.isTranslating = true;

                const functions = getFunctions();
                const translateSubtitle = httpsCallable(functions, "translateSubtitle");
                /* const res = */await translateSubtitle({
                    segmentId: this.audioData.audioDataId,
                    targetLanguageCode: this.selectedTranslationLanguage.value, // "ar-OM",
                    targetLanguageName: this.selectedTranslationLanguage.text, // "العربية (عُمان) | Arabic (Oman)",
                });
                this.successText = "Subtitles translated successfully!";
            } catch (error) {
                console.error(error);
                // this.$store.commit("alertUser", { show: true, text: "Failed to translate subtitle.", type: "snackbar" });
                this.successText = `Failed to translate subtitles. ${error.message || error}`;
                wasSuccessfullyTranslated = false;
            } finally {
                setTimeout(() => {
                    this.isTranslating = false;
                    this.closeSubtitleTranslation(wasSuccessfullyTranslated); // Optionally refresh the segment from Firestore or rely on snapshot listener
                }, 2500);
            }
        },
    },
    computed: {
        languageCodes: function () {
            const codes = this.$languageCodes || [];
            const excludePrefixes = new Set();

            const audioLanguageCode = this.audioData && this.audioData.audioData ? this.audioData.audioData.languageCode : null;
            if (audioLanguageCode) {
                excludePrefixes.add(audioLanguageCode.split("-")[0].toLowerCase());
            }

            const subtitlesByLanguage = this.audioData && this.audioData.audioData ? this.audioData.audioData.subtitlesByLanguage : null;
            if (subtitlesByLanguage && typeof subtitlesByLanguage === "object") {
                Object.keys(subtitlesByLanguage).forEach((languageCode) => {
                    if (!languageCode) {
                        return;
                    }
                    const prefix = languageCode.split("-")[0].trim().toLowerCase();
                    if (prefix) {
                        excludePrefixes.add(prefix);
                    }
                });
            }

            if (excludePrefixes.size === 0) {
                return codes;
            }

            return codes.filter((language) => {
                const value = (language.value || "").toLowerCase();
                for (let prefix of excludePrefixes) {
                    if (value.startsWith(prefix)) {
                        return false;
                    }
                }
                return true;
            });
        },
    },
    // mounted: function() {},
}
</script>
